export const lessonSelector = (state) => state.lesson;
export const lessonUploadsSelector = (state) => state.lesson?.uploads;
